// import MD5 from 'md5'

const DEBUG_OPT = {
  'get': {
    'url': '/ukdebug/dataLog/get',
    'method': 'get'
  },
  'save': {
    'url': '/ukdebug/dataLog/save',
    'method': 'post',
    'json': true
  }
}

/**
 * 负责人：zhijie.huang
 * 接口数据写入本地备份
 * @param {object} data 写入的基础数据
 * @param {object} opt 写入的传参对象
 * @return {Promise} promise对象
 * */
// const dataLogger = function (data, opt) {
//   return new Promise(function (resolve, reject) {
//     let param = {}
//     try {
//       if (typeof opt.data === 'string') {
//         param = JSON.parse(opt.data)
//       } else {
//         param = opt.data
//       }
//       deAuthorize(param)
//     } catch (err) {
//       console.warn('dataLogger error', err, opt.url)
//     }
//     let conditions = setCondition(param)

//     ajax.ajax({
//       url: '/ukdebug/dataLog/save',
//       method: 'post',
//       json: true,
//       data: {
//         data: data,
//         url: opt.url,
//         param: param,
//         conditions: conditions
//       },
//       hideLoading: true
//     }).then(function (e) {
//       if (resolve) {
//         resolve(e)
//       }
//     }, function (e) {
//       if (resolve) {
//         reject(e)
//       }
//     })
//   })
// }

class ApiTest {
  /**
   * 构造函数，传入类和ajax方法
   * @param {*} logicInstance
   * @param {*} ajaxFun
   */
  constructor (logicInstance, ajaxFun) {
    this.ajaxDebug = this._decorator(logicInstance, ajaxFun)
  }

  // 装饰方法
  _decorator (that, fn) {
    const _self = that
    return function () {
      // console.info('decorator', arguments, _self)
      let args = arguments
      this._toDebug(args)
      return fn.apply(_self, arguments)
    }
  }
  // 跳debug接口
  _toDebug (args) {
    for (let i = 0; i < args.length; i++) {
      const item = args[i]
      if (item && item.test) {
        const oldUrl = item.url
        const data = {
          conditions: this._setCondition(item.data),
          url: oldUrl
        }
        args[i] = {
          ...DEBUG_OPT.get,
          data: data
        }
        break
      }
    }
  }

  /**
   * 设置接口的查询条件唯一标识
   * @param {object} data 接口入参
   * @return {string} conditions
   * */
  _setCondition (data) {
    let conditions = '0123456789'
    if (typeof data === 'string') {
      data = JSON.parse(data)
    }
    if (data && typeof data === 'object') {
      this._deAuthorize(data)
      conditions = MD5(JSON.stringify(data)).toLowerCase()
    }
    return conditions
  }

  /**
   * 去除授权相关的字段填充
   * @param {object} d 需要去除授权的对象
   * @return {object} 去除授权的字段
   * */
  _deAuthorize (d) {
    delete d.loginCustomerId
    delete d.streamNo
    delete d.partnerCode
    return d
  }
}

export default ApiTest



// WEBPACK FOOTER //
// ./src/logic/api-test.js